var storeSelection, getPrecog;

(function ($) {


	/**
	 * Saves selected values in filters so that they can be restored 
	 * if we change to another page and then change back again
	 */
	storeSelection = function($filters, key, inputType) {

		try {
			var selection = {};

			$filters.each(function () {
				
				switch(inputType) {
					case 'select': 
						selection[key] = $(this).data('value');
						break;
					case 'button': 
						var stepNumber = $(this).attr('data-step-number'),
							pageIDIndex = $('body').attr("class").indexOf("page-id-"),
							pageID = $('body').attr("class").substr(pageIDIndex);

						selection[pageID + '_' + stepNumber] = $(this).attr('data-' + key);
						break;
					default:
						break;
				}

			});

			localStorage.setItem(inputType, JSON.stringify(selection));

			return true;
		} catch (e) {
			if (window.console) {
				window.console.log(e);
			}
		}
	};



	/**
	 * Fetches precog values from localStorage and sets the filter
	 * pulldowns according to previously stored values
	 */
	getPrecog = function($filters, key, inputType) {
		try {
			if ((precogs = JSON.parse(localStorage.getItem(inputType)))) {
				
				jQuery.each(precogs, function (precog_key, precog_value) {

					switch(inputType) {
						case 'select':
							$filters.filter('[' + precog_key + ']').each(function () {
								$(this).data('value', precog_value);
								
								var text = $('[data-value="' + precog_value + '"]:not([data-postlist-filter])').text();
								$(this).parents().find('.select-toggle .text').text(text);
							});

							$filters.trigger('datachange.listfilter');
							break;
						case 'button':
							var stepNr = precog_key.substr(precog_key.indexOf("_") + 1);
							$filters.filter('[data-step-number="' + stepNr + '"]').attr('data-' + key, precog_value);
							break;
						default:
							break;
					}

				});
			}
		} catch (e) {
			if (window.console) {
				window.console.log(e);
			}
		}
	};

}(jQuery));